import useItemsHook from '../../_hooks/useItemsHook'
import mapper from '../../_endpoints'
import {
  AppIcon,
  AppIconWithNameContainer,
  AppName,
  AppsHeaderContainer,
  AppsRecommendedContainer,
  SuggestedAppsContainer,
  ButtonContainer,
  Main,
  SubHeaderContainer,
  SubHeaderText,
  StyledScrollbar
} from './SuggestedApps.styled'
import AppCtaButton from '../_organisms/AppCtaButton'
import { SpinnerWrapper } from '../../styles/common'
import { Spinner } from 'reactstrap'
import { Avatar } from 'dsm-react-lib'
import { useSasToken } from '../../_hooks/useSasToken'

const SuggestedApps = ({ setOpenPanel, application }) => {
  const [{ items: recommendedApps, spinner: isLoading }] = useItemsHook(
    mapper.recommendation.appSpecificRecommendations.replace(':id', application?.uniqueName)
  )
  const { appendToken } = useSasToken()

  const postCtaButtonClick = () => {
    setOpenPanel(false)
  }

  return (
    <>
      <Main>
        <SubHeaderContainer>
          <SubHeaderText>Because you are using</SubHeaderText>
          <SubHeaderText>
            <b>{application?.name}</b>
          </SubHeaderText>
        </SubHeaderContainer>

        {isLoading ? (
          <SpinnerWrapper>
            <Spinner color="primary" />
          </SpinnerWrapper>
        ) : (
          <StyledScrollbar>
            <SuggestedAppsContainer>
              {recommendedApps && recommendedApps?.data?.length ? (
                <AppsHeaderContainer>Apps</AppsHeaderContainer>
              ) : (
                `No related applications for ${application?.name}`
              )}

              {recommendedApps &&
                recommendedApps?.data?.length > 0 &&
                recommendedApps?.data?.slice(0, 5).map((app, index) => (
                  <AppsRecommendedContainer key={index}>
                    <AppIconWithNameContainer>
                      <AppIcon>
                        <Avatar
                          content={appendToken(app?.appIcon?.url)}
                          size="50px"
                          shape="rounded"
                        />
                      </AppIcon>
                    </AppIconWithNameContainer>
                    <AppName>
                      <b>{app.name}</b>
                    </AppName>
                    <ButtonContainer className="ms-auto">
                      <AppCtaButton
                        app={app}
                        size={'small'}
                        outline={true}
                        postCtaButtonClick={postCtaButtonClick}
                        data-testid={`SuggestedAppsBtn-${app.uniqueName}`}
                        hasSuggestedApps={true}
                      />
                    </ButtonContainer>
                  </AppsRecommendedContainer>
                ))}
            </SuggestedAppsContainer>
          </StyledScrollbar>
        )}
      </Main>
    </>
  )
}

export default SuggestedApps
